import {combineReducers, Reducer} from '@reduxjs/toolkit'

import {routerReducer} from '@web/slices/router'

import {RootState} from '../interfaces'
import common from '../slices/common'
import deliveryInfo from '../slices/deliveryInfo'

const createRootReducer = (): Reducer<RootState> =>
    combineReducers({
        common,
        deliveryInfo,
        router: routerReducer,
    })

export default createRootReducer
